import React, { useCallback } from 'react';
import { Button, Field, HeaderSection, Text } from '@groupelacentrale/contact-storybook';
import { FormikProps } from 'formik';
import { ContactInformationPro } from 'types';
import './ContactInformationProForm.scss';
import OneToMany from 'components/OneToMany/OneToMany';
import cx from 'classnames';

interface Props {
  emails: string[];
  handleReturn: () => void | undefined;
  showActions?: boolean;
  updatedFields?: {
    phone?: boolean;
    contact?: boolean;
    phone2?: boolean;
    contact2: boolean;
    zipCode?: boolean;
    email?: boolean;
  };
}

export const ContactInformationProFormView: React.FC<FormikProps<ContactInformationPro> & Props> = ({
  emails,
  values,
  isSubmitting,
  touched,
  errors,
  setFieldValue,
  handleChange,
  handleSubmit,
  handleReturn,
  showActions,
  updatedFields,
}) => {
  const handleEmailSelect = useCallback((selectedValue: string) => setFieldValue('email', selectedValue), [
    setFieldValue,
  ]);

  return (
    <>
      {showActions !== false && <HeaderSection noUnderline>Vos coordonnées de contact</HeaderSection>}
      <div className="fields">
        <Field
          name="phone"
          label="Téléphone*"
          value={values.phone}
          minLength="10"
          maxLength="10"
          onChange={handleChange}
          errorMessage={touched.phone ? errors.phone : undefined}
          className={updatedFields?.phone ? 'updated-field' : undefined}
        />
        <Field
          name="contact"
          label="Contact"
          value={values.contact || ''}
          onChange={handleChange}
          errorMessage={touched.contact ? errors.contact : undefined}
          className={updatedFields?.contact ? 'updated-field' : undefined}
        />
        <Field
          name="phone2"
          label="Téléphone 2"
          value={values.phone2}
          minLength="10"
          maxLength="10"
          onChange={handleChange}
          errorMessage={touched.phone2 ? errors.phone2 : undefined}
          className={updatedFields?.phone2 ? 'updated-field' : undefined}
        />
        <Field
          name="contact2"
          label="Contact 2"
          value={values.contact2 || ''}
          onChange={handleChange}
          errorMessage={touched.contact2 ? errors.contact2 : undefined}
          className={updatedFields?.contact2 ? 'updated-field' : undefined}
        />
        <Field
          name="zipCode"
          label="Code postal"
          value={values.zipCode}
          onChange={handleChange}
          errorMessage={touched.zipCode ? errors.zipCode : undefined}
          className={updatedFields?.zipCode ? 'updated-field' : undefined}
        />
        <OneToMany
          name="email"
          label={<Text className={cx('field-label', { 'updated-field': updatedFields?.email })}>Email*</Text>}
          placeholder="Sélectionnez une adresse email"
          value={values.email}
          options={emails}
          onSelect={handleEmailSelect}
          errorMessage={touched.email ? errors.email : undefined}
        />
        <Text>
          Pour utiliser une autre adresse électronique merci d’appeler le <b>01 77 49 01 86</b>
        </Text>
        <Text>* champ obligatoire</Text>
      </div>

      {showActions !== false && (
        <div className="actions">
          <Button label="Retour" theme="quaternary" type="button" onClick={handleReturn} />
          <Button
            label="Valider et continuer"
            disabled={!(values.email && values.phone) || isSubmitting}
            loading={isSubmitting}
            type="submit"
            onClick={handleSubmit}
          />
        </div>
      )}
    </>
  );
};
